<template>
  <div class="modal fade close-view-recording-modal real-close" id="RecordingModal" tabindex="-1" aria-hidden="true" @click="closeModal()">
      <div class="modal-dialog modal-dialog-centered custom-device-style">
        
        <div class="modal-content">
              <!-- <div class="area-loading-recording-modal radius-7" v-if="loadingAudioPlayer">
                <span class="title-loading-recording-modal">Carregando...</span>
              </div> -->
              
              <div class="area-message-recording-modal radius-7" v-if="videoNotFound">
                <span class="title-message-recording-modal">Video não encontrado neste período de tempo</span>
              </div>

              <div class="modal-header">
                  <h1 class="modal-title fs-5">{{ getCurrentRecording[0] != null ? getCurrentRecording[0].name : '' }}</h1>
                  <button type="button" class="btn-close close-view-recording-modal real-close" data-bs-dismiss="modal" @click="closeModal()" aria-label="Close"></button>
              </div>

              <div v-for="(value) in getCurrentRecording" :key="value.key" class="recording-modal-body modal-body">
                
                <div class="recording-address space-device-information" v-if="value.address">
                  <strong class="fs-16">Endereço:</strong> {{ value.address.street }}, {{ value.address.number }} - {{ value.address.zip_code }} - {{ value.address.city }} <br>
                </div>

                <div class="recording-content template-custom-cameras mt-2">
                  <div class="recording-content-inner w-100">

                    <!-- <video id="video-player-custom" class="video-js vjs-default-skin list-cam-live-custom w-100 radius-top-7" preload="auto" height="400" crossorigin="anonymous" data-setup='{}'>
                      <source :src="value.url" type="application/x-mpegURL" />
                            Seu navegador não suporta a reprodução de HLS.
                    </video> -->
                    <PlayerComponent 
                      :key="videoKey + 1" v-if="liveUrl != null" 
                      :cameraToken="value.token"
                      :liveUrl="liveUrl" 
                      :mime="mime" 
                      :startAt="startAt" 
                      :finishTimeVideo="finishTimeVideo" 
                      :isLoading="loadingAudioPlayer"
                      @video-ended="fetchAndPlayVideo"
                    />

                    <div v-if="!hasStreamConfigured" class="area-message-camera-stream radius-7">
                      <i class="flaticon flaticon-video-camera fs-30 mb-10"></i>
                      <span class="title-message-camera-stream">Camera sem transmissao configurada</span>
                      <span class="subtitle-message-camera-stream">Esta camera ainda nao possui URL/IP de stream cadastrado.</span>
                    </div>

                    <TimelineComponent 
                      v-if="hasStreamConfigured"
                      :camera-token="value.token"
                      :date="timelineDate"
                      :refresh-key="timelineRefreshKey"
                      :selection-mode="downloadSelectionMode"
                      :selection-start="downloadStart"
                      :selection-end="downloadEnd"
                      @clickTimeLine="clickTimeLine"
                      @unavailableTime="handleUnavailableTimeline"
                      @selectionChange="handleDownloadSelection"
                    />

                    <div v-if="hasStreamConfigured" class="recording-timeline-hint">
                      <i class="ph ph-clock-counter-clockwise" aria-hidden="true"></i>
                      <span v-if="downloadSelectionMode">Arraste os dois marcadores para escolher o trecho.</span>
                      <span v-else>Toque em um horário da linha do tempo para assistir à gravação.</span>
                    </div>

                    <section v-if="hasStreamConfigured" class="download-selector">
                      <div v-if="downloadSuccess" class="download-processing-notice" role="status" aria-live="polite">
                        <i class="ph ph-check-circle" aria-hidden="true"></i>
                        <div>
                          <strong>Pedido confirmado</strong>
                          <span>O trecho já está sendo processado. Acompanhe o andamento em <router-link to="/downloads" data-bs-dismiss="modal">Downloads</router-link>.</span>
                        </div>
                      </div>

                      <button v-else-if="!downloadSelectionMode" type="button" class="btn btn-outline-primary download-selector-toggle" @click="startDownloadSelection">
                        <i class="ph ph-download-simple me-2" aria-hidden="true"></i>
                        Baixar gravação
                      </button>

                      <div v-else class="download-selector-panel">
                        <div class="download-selector-heading">
                          <div><strong>Trecho para download</strong><small>Escolha de 1 segundo a 10 minutos. O intervalo pode atravessar a meia-noite.</small></div>
                          <button type="button" class="btn btn-sm btn-light" @click="cancelDownloadSelection">Cancelar</button>
                        </div>
                        <div class="download-datetime-grid">
                          <label><span>Início</span><input v-model="downloadStartInput" type="datetime-local" step="1" class="form-control" @change="syncDownloadInputs" /></label>
                          <label><span>Fim</span><input v-model="downloadEndInput" type="datetime-local" step="1" class="form-control" @change="syncDownloadInputs" /></label>
                        </div>
                        <div class="download-duration" :class="{ invalid: !downloadSelectionValid }"><span>Duração selecionada</span><strong>{{ formattedDownloadDuration }}</strong></div>
                        <p v-if="downloadSelectionError" class="download-error">{{ downloadSelectionError }}</p>
                        <div v-if="downloadConfirmation" class="download-confirmation">
                          <strong>Confirme o trecho</strong>
                          <span>{{ value.name }} • {{ formatDownloadDate(downloadStart) }} até {{ formatDownloadDate(downloadEnd) }}</span>
                        </div>
                        <div class="download-actions">
                          <button v-if="downloadConfirmation" type="button" class="btn btn-light" @click="downloadConfirmation = false">Voltar</button>
                          <button type="button" class="btn btn-primary" :disabled="!downloadSelectionValid || downloadSubmitting" @click="downloadConfirmation ? createRecordingDownload(value.token) : requestDownloadConfirmation()">
                            {{ downloadSubmitting ? 'Criando...' : (downloadConfirmation ? 'Confirmar download' : 'Continuar') }}
                          </button>
                        </div>
                      </div>
                    </section>

                    <div v-if="hasStreamConfigured && !downloadSelectionMode" class="timeline-wrapper">
                      <!-- <div class="times-area d-none d-sm-flex d-lg-flex d-xl-flex d-xxl-flex d-xxxl-flex">
                        <div class="times-div border-bottom-left-radius">
                          <span>00:00</span>
                        </div>
                        <div 
                          class="timeline-area" 
                          @click="calculateTimeOnClick"
                          @mousemove="calculateTime" 
                          @mouseleave="resetTime"
                        >

                          <div class="elapsed-time-bar" :style="{ width: currentTimePosition + '%' }"></div>

                          <div 
                            class="current-time-indicator" 
                            :style="{ left: currentTimePosition + '%' }"
                          ></div>
                          
                          <div 
                            class="timeline-segment-custom" 
                            :style="{ left: markerPosition + 'px', display: isMarkerVisible ? 'block' : 'none' }"
                          >
                          <span class="style-time-span">{{ timeDisplay }}</span>
                          </div>
                        </div>
                        <div class="times-div border-bottom-right-radius">
                          <span>24:00</span>
                        </div>
                      </div> -->
                      <div class="recording-controls d-flex justify-content-between flex-column flex-column-row flex-sm-row flex-lg-row flex-xl-row flex-xxl-row flex-xxxl-row space-device-information">

                        <div class="recording-search-row area-search-recording row p-10 flex-row col-column-12 col-sm-6 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
                          <input
                            class="input-date-range flatpickr form-control fs-md-15 text-black shadow-none col-12 col-sm-12 mb-2 mb-sm-0"
                            type="text"
                            placeholder="Selecione a data"
                            id="basicCalendar"
                            ref="datePickr"
                          />
  
                          <button id="buttonSearchRecordingsApi" type="button" class="btn btn-success ms-sm-10 ms-lg-10 ms-xl-10 ms-xxl-10 ms-xxxl-10 col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4 col-xxxl-4" @click="searchRecordings()">Buscar</button>
                        </div>

                        <div class="recording-live-row area-search-recording row p-10 flex-column flex-column-row flex-sm-row flex-lg-row flex-xl-row flex-xxl-row flex-xxxl-row">
                          <button id="liveButton" class="live-button d-flex justify-content-center align-items-center" @click="goLive">
                            <i class="flaticon flaticon-video-camera fs-16 d-flex align-items-center me-2"></i>
                            VER AO VIVO
                          </button>
                        </div>
                      </div>
                    </div>



                    
                  </div>
                </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js"
import "video.js/dist/video-js.css";
import api from '../../config/axios.js';
import PlayerComponent from './PlayerComponent.vue';
import TimelineComponent from './TimelineComponent.vue';

function formatLocalDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

function formatDateTimeLocal(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  const second = String(date.getSeconds()).padStart(2, '0');
  return `${formatLocalDate(date)}T${hour}:${minute}:${second}`;
}

function toIsoWithOffset(date) {
  const offset = -date.getTimezoneOffset();
  const sign = offset >= 0 ? '+' : '-';
  const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, '0');
  const minutes = String(Math.abs(offset) % 60).padStart(2, '0');
  return `${formatDateTimeLocal(date)}${sign}${hours}:${minutes}`;
}

export default {
  name: "RecordingModal",
  data () {
    return {
      loadingAudioPlayer: false,
      errorMessage: "",
      player: null,
      markerPosition: 0,
      isMarkerVisible: false,
      timeDisplay: "",
      currentTimePosition: 0,
      videoKey: 0,
      videoNotFound: false,
      dataPlayer: null,
      timeVariable: false,
      lastDay: null,
      timeoutTimeline: null,
      liveUrl: null,
      hasStreamConfigured: false,
      mime: 'application/x-mpegURL',
      startAt: 0,
      finishTimeVideo: null,
      timelineDate: formatLocalDate(new Date()),
      timelineRefreshKey: 0,
      downloadSelectionMode: false,
      downloadStart: null,
      downloadEnd: null,
      downloadStartInput: '',
      downloadEndInput: '',
      downloadConfirmation: false,
      downloadSubmitting: false,
      downloadSelectionError: '',
      downloadSuccess: false,
    }
  },
  components: {
    PlayerComponent,
    TimelineComponent
  },
  computed:{
    ...mapGetters([
        'getCurrentRecording',
        'getCurrentUrlRecording',
        'getRecordingShowModalState',
        'getCurrentSearchCamera'
    ]),
    downloadDurationSeconds() {
      if (!this.downloadStart || !this.downloadEnd) return 0;
      return Math.round((new Date(this.downloadEnd).getTime() - new Date(this.downloadStart).getTime()) / 1000);
    },
    downloadSelectionValid() {
      return this.downloadDurationSeconds >= 1
        && this.downloadDurationSeconds <= 600
        && new Date(this.downloadEnd) <= new Date();
    },
    formattedDownloadDuration() {
      const seconds = Math.max(0, this.downloadDurationSeconds);
      return `${Math.floor(seconds / 60)}min ${String(seconds % 60).padStart(2, '0')}s`;
    }
  },
  watch: {
    getCurrentRecording(data) {
    if (data) {
        if(data.length === 0){
          this.liveUrl = null;
          this.hasStreamConfigured = false;
          return;
        }

        this.liveUrl = data[0].url;
        this.hasStreamConfigured = Boolean(data[0].url);
        this.startAt = 0;
        this.mime = 'application/x-mpegURL';
        this.timelineDate = formatLocalDate(new Date());
        this.timelineRefreshKey += 1;
        this.cancelDownloadSelection();
        setTimeout(() => {

          flatpickr("#basicCalendar", {
            enableTime: true,         
            enableSeconds: true,      
            time_24hr: true,
            minuteIncrement: 1,
            locale: Portuguese,
            dateFormat: "d/m/Y H:i:S",
            defaultDate: new Date()
          });
        }, 1000);


        this.dataPlayer = new Date();
 
        // Atualiza a posição inicial do horário atual
        this.updateCurrentTimePosition();

        if (!this.hasStreamConfigured) {
          return;
        }

        // Atualiza a posição do marcador a cada minuto
        this.timeoutTimeline = setInterval(() => {

          if(this.timeVariable){

            if(this.dataPlayer.getDate() !== this.lastDay){

              flatpickr("#basicCalendar", {
                enableTime: true,         // Habilita a seleção de hora
                enableSeconds: true,      // Habilita os segundos
                time_24hr: true,          // Usa o formato 24h
                locale: Portuguese,
                minuteIncrement: 1,
                dateFormat: "d/m/Y H:i:S",
                defaultDate: this.dataPlayer
              });
            }

            this.lastDay = this.dataPlayer.getDate();
            this.dataPlayer.setMinutes(this.dataPlayer.getMinutes() + 1);

          } else {
            this.dataPlayer = new Date();
          }

          console.log("Atualizando a posição do horário atual:", this.dataPlayer);

          this.updateCurrentTimePosition();
        }, 60000);

    }
  }
},
  beforeUnmount() {
    console.log("Desmontando o modal de gravação");
    if (this.player != null) {
      this.player.dispose();
      this.player = null;
    }
  },
  methods: {
    ...mapActions([
      "setRecordingShowModalState",
      "setCurrentRecording"
    ]),
    startDownloadSelection() {
      const now = new Date();
      const selected = this.dataPlayer instanceof Date && this.dataPlayer < now ? new Date(this.dataPlayer) : null;
      const start = selected && now.getTime() - selected.getTime() >= 60000
        ? selected
        : new Date(now.getTime() - 60000);
      const end = new Date(Math.min(start.getTime() + 60000, now.getTime()));
      this.downloadSelectionMode = true;
      this.downloadStart = start;
      this.downloadEnd = end;
      this.downloadStartInput = formatDateTimeLocal(start);
      this.downloadEndInput = formatDateTimeLocal(end);
      this.downloadSelectionError = '';
      this.downloadSuccess = false;
      this.downloadConfirmation = false;
      this.timelineDate = formatLocalDate(start);
    },
    cancelDownloadSelection() {
      this.downloadSelectionMode = false;
      this.downloadStart = null;
      this.downloadEnd = null;
      this.downloadStartInput = '';
      this.downloadEndInput = '';
      this.downloadConfirmation = false;
      this.downloadSelectionError = '';
      this.downloadSuccess = false;
    },
    handleDownloadSelection({ start, end }) {
      this.downloadStart = new Date(start);
      this.downloadEnd = new Date(end);
      this.downloadStartInput = formatDateTimeLocal(this.downloadStart);
      this.downloadEndInput = formatDateTimeLocal(this.downloadEnd);
      this.downloadConfirmation = false;
      this.downloadSelectionError = '';
      this.timelineDate = formatLocalDate(this.downloadStart);
    },
    syncDownloadInputs() {
      const start = new Date(this.downloadStartInput);
      const end = new Date(this.downloadEndInput);
      if (!Number.isNaN(start.getTime()) && !Number.isNaN(end.getTime())) this.handleDownloadSelection({ start, end });
    },
    requestDownloadConfirmation() {
      if (!this.downloadSelectionValid) {
        this.downloadSelectionError = this.downloadDurationSeconds > 600
          ? 'O trecho não pode ultrapassar 10 minutos.'
          : 'Escolha um intervalo passado com pelo menos 1 segundo.';
        return;
      }
      this.downloadSelectionError = '';
      this.downloadConfirmation = true;
    },
    async createRecordingDownload(cameraToken) {
      if (!this.downloadSelectionValid || this.downloadSubmitting) return;
      this.downloadSubmitting = true;
      this.downloadSelectionError = '';
      try {
        await api.axios.post('/api/recording-downloads', {
          camera_token: cameraToken,
          start_at: toIsoWithOffset(new Date(this.downloadStart)),
          end_at: toIsoWithOffset(new Date(this.downloadEnd))
        });
        this.downloadSelectionMode = false;
        this.downloadStart = null;
        this.downloadEnd = null;
        this.downloadStartInput = '';
        this.downloadEndInput = '';
        this.downloadSuccess = true;
        this.downloadConfirmation = false;
        this.downloadSelectionError = '';
      } catch (error) {
        this.downloadSelectionError = error?.response?.data?.message || 'Não foi possível criar o download.';
      } finally {
        this.downloadSubmitting = false;
      }
    },
    formatDownloadDate(value) {
      return new Date(value).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'medium' });
    },
    goLive() {
      if (!this.hasStreamConfigured) {
        return;
      }

      this.timelineDate = formatLocalDate(new Date());
      this.timelineRefreshKey += 1;

      this.mime = 'application/x-mpegURL';
      this.liveUrl = this.getCurrentRecording[0].url;
      this.startAt = 0;
      this.finishTimeVideo = null;
      this.videoKey = this.videoKey + 1;

      this.timeVariable = false;
      this.dataPlayer = new Date();
      this.updateCurrentTimePosition();

      flatpickr("#basicCalendar", {
        enableTime: true,
        enableSeconds: true,
        time_24hr: true,
        minuteIncrement: 1,
        locale: Portuguese,
        dateFormat: "d/m/Y H:i:S",
        defaultDate: new Date()
      });

    },
    clickTimeLine(timeClieckedTimeLine){
      console.log("Clicou na linha do tempo", timeClieckedTimeLine);
      this.loadingAudioPlayer = true;
      const clickedSeconds = this.secondsOfDay(timeClieckedTimeLine);
      const datetime = timeClieckedTimeLine.replace('T', ' ');
      // console.log("datetime", datetime, clickedTime, clickedSeconds);
      this.timeVariable = true;

      if(this.verificarDataMaior(datetime)){
        console.log("Data maior que a atual, voltando ao ao vivo");
        this.goLive();
        this.loadingAudioPlayer = false;

        this.dataPlayer = new Date();
        this.updateCurrentTimePosition();

        return;
      } else {

        this.dataPlayer = new Date(timeClieckedTimeLine);
        this.updateCurrentTimePosition();

      }

      // 📌 Chama a nova função para buscar metadados + carregar vídeo
      this.fetchAndPlayVideo(this.getCurrentRecording[0].token, datetime, clickedSeconds);
    },
    handleUnavailableTimeline() {
      this.showVideoNotFound();
    },
    showVideoNotFound() {
      this.videoNotFound = true;
      setTimeout(() => {
        this.videoNotFound = false;
      }, 2000);
    },
    secondsOfDay(timestamp) {
      const data = new Date(timestamp);
      return data.getHours() * 3600 + data.getMinutes() * 60 + data.getSeconds();
    },
    closeModal(){

      if (event.target.classList.contains("real-close")) {
        if (this.timeoutTimeline) {
            clearTimeout(this.timeoutTimeline);
        }
        this.setCurrentRecording([]);
        this.setRecordingShowModalState(false);
      }

    },
    // METODOS PARA O PLAYER DE VÍDEO
    turnOffPlayer(){
      if(this.player != null){
        this.player.dispose();
        this.player = null;
      }
    },
    // Função para voltar ao stream ao vivo
    loadLiveStream() {
      this.createPlayer(this.getCurrentRecording[0].url);
    },
    // Método que atualiza a posição do horário atual e a largura da barra azul
    updateCurrentTimePosition() {
      // Captura as horas e minutos
      const hours = parseInt(this.dataPlayer.getHours(), 10);
      const minutes = parseInt(this.dataPlayer.getMinutes(), 10);

      // Total de minutos no dia
      const totalMinutes = (hours * 60) + minutes;
      const totalDayMinutes = 24 * 60; // 1440 minutos no dia

      // Calcula a porcentagem
      this.currentTimePosition = (totalMinutes / totalDayMinutes) * 100;
    },
    // Função para formatar o horário
    formatTime(hours, minutes, seconds) {
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    },
    // Calcula o horário baseado na posição do mouse
    calculateTime(event) {
      const timelineArea = event.currentTarget;
      const rect = timelineArea.getBoundingClientRect();
      const timelineWidth = rect.width;

      // Posição do mouse em relação à régua
      const mouseX = event.clientX - rect.left;

      // Porcentagem da posição na régua
      const percentage = mouseX / timelineWidth;

      // Calcular o horário com base na porcentagem (0h a 24h)
      const totalSeconds = Math.floor(percentage * 24 * 60 * 60); // Convertendo para segundos
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      // Atualizar o estado do marcador e horário
      this.markerPosition = mouseX;
      this.isMarkerVisible = true;

      // Garantir que valores negativos não ocorram
      if (hours < 0) hours = 0;
      if (minutes < 0) minutes = 0;
      if (seconds < 0) seconds = 0;

      // Atualiza a exibição do tempo no formato HH:MM:SS
      this.timeDisplay = this.removerHora(this.$refs.datePickr[0].value) + ` - ${this.formatTime(hours, minutes, seconds)}`;
    },
    // Reseta o marcador e a exibição ao sair da régua
    resetTime() {
      this.isMarkerVisible = false;
      this.timeDisplay = "";
    },
    searchRecordings(){
      this.loadingAudioPlayer = true;
      this.timeVariable = true;

      const formattedDateTime = this.formatarData(this.$refs.datePickr[0].value);
      const dateSearch = formattedDateTime.split(" ")[1];
      const hourSplit = dateSearch.split(":");

      const hours = Math.max(0, hourSplit[0]);
      const minutes = Math.max(0, hourSplit[1]);
      const seconds = Math.max(0, hourSplit[2]);

      const clickedSeconds = hours * 3600 + minutes * 60 + seconds;

      this.timelineDate = formattedDateTime.split(" ")[0];
      this.timelineRefreshKey += 1;
      this.dataPlayer = new Date(formattedDateTime.replace(" ", "T"));
      this.updateCurrentTimePosition();

      this.fetchAndPlayVideo(this.getCurrentRecording[0].token, formattedDateTime, clickedSeconds);
    },
    formatarData(dataString) {
      // Separar data e hora
      let [data, hora] = dataString.split(" ");

      // Separar dia, mês e ano
      let [dia, mes, ano] = data.split("/");

      // Retornar no formato desejado
      return `${ano}-${mes}-${dia} ${hora}`;
    },
    calculateTimeOnClick(event) {
      this.loadingAudioPlayer = true;

      const timelineArea = event.currentTarget;
      const rect = timelineArea.getBoundingClientRect();
      const timelineWidth = rect.width;

      // Posição do clique em relação à régua
      const mouseX = event.clientX - rect.left;

      // Porcentagem da posição na régua
      const percentage = mouseX / timelineWidth;

      // Calcular o horário com base na porcentagem (0h a 24h)
      const totalSeconds = Math.floor(percentage * 24 * 60 * 60);
      let hours = Math.floor(totalSeconds / 3600);
      let minutes = Math.floor((totalSeconds % 3600) / 60);
      let seconds = totalSeconds % 60;

      // Garantir que valores negativos não ocorram
      hours = Math.max(0, hours);
      minutes = Math.max(0, minutes);
      seconds = Math.max(0, seconds);

      // Formatar o horário clicado para envio
      const clickedTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
      const clickedSeconds = hours * 3600 + minutes * 60 + seconds;

      // Converter a data selecionada para o formato correto (YYYY-MM-DD)
      const dateFormatted = this.convertDateToISO(this.removerHora(this.$refs.datePickr[0].value));
      const datetime = `${dateFormatted} ${clickedTime}`;
      console.log("datetime", datetime, clickedTime, clickedSeconds);
      this.timeVariable = true;

      if(this.verificarDataMaior(datetime)){
        this.goLive();
        this.loadingAudioPlayer = false;

        this.dataPlayer = new Date();
        this.updateCurrentTimePosition();

        return;
      } else {

        this.dataPlayer = new Date(dateFormatted + "T" + clickedTime);
        this.updateCurrentTimePosition();

      }

      // 📌 Chama a nova função para buscar metadados + carregar vídeo
      this.fetchAndPlayVideo(this.getCurrentRecording[0].token, datetime, clickedSeconds);
    },
    verificarDataMaior(dataString) {
      let dataFornecida = new Date(dataString.replace(" ", "T"));
      let dataAtual = new Date();

      return dataFornecida > dataAtual;
    },

    async fetchAndPlayVideo(cameraToken, datetime, clickedSeconds) {
      try {

          // 📌 Primeiro, buscar os metadados da gravação
          const metadataResponse = await api.axios.post(
              `/api/recording/metadata/${cameraToken}/${datetime}`, null
          );

          if (!metadataResponse.data) {
              this.loadingAudioPlayer = false;
              return;
          }

          // 📌 Converter `recorded_at` para timestamp Unix
          const recordedTimestamp = Math.floor(new Date(metadataResponse.data.recorded_at).getTime() / 1000);

          // 📌 Criar timestamp Unix para `clickedSeconds` baseado na data selecionada
          const clickedTimestamp = Math.floor(new Date(`${datetime.split(" ")[0]} 00:00:00`).getTime() / 1000) + clickedSeconds;

          // 📌 Calcular o tempo exato dentro do vídeo
          const startTime = clickedTimestamp - recordedTimestamp;

          const response = await api.axios.post(`/api/recording/timeline/${cameraToken}/${datetime}`);
          const signedUrl = response.data.url;
          if (!signedUrl) {
              this.loadingAudioPlayer = false;
              return;
          }

          this.liveUrl = signedUrl;
          this.mime = 'video/mp4';
          this.startAt = startTime > 0 ? startTime : 0;
          this.finishTimeVideo = metadataResponse.data.recording_ends_at
          this.videoKey = this.videoKey + 1;

      } catch (error) {
          this.showVideoNotFound();
      }
      this.loadingAudioPlayer = false;
    },
    removerHora(valor) {
      return valor.split(" ")[0];
    },
    convertDateToISO(dateString) {
      if (!dateString) return "";

      // Divide a string pelo caractere "/"
      const [day, month, year] = dateString.split("/");

      // Retorna a data no formato YYYY-MM-DD
      return `${year}-${month}-${day}`;
    },
  }
};
</script>

<style scoped>
  .timeline {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
  }
  
  .timeline-item {
    padding: 10px 20px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
  }
  
  .timeline-item:hover {
    /* background: #0056b3; */
  }
  
  .live-button {
    padding: 10px 20px;
    background: #28a745;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
  }
  
  .live-button:hover {
    /* background: #1e7e34; */
  }
  
  .timeline-segment-custom{
      cursor: pointer;
      /* border-top-left-radius: 4px; */
      /* border-bottom-left-radius: 4px; */
      /* left: 0% !important; */
      height: 100%;
      width: 50%;
      background: #007bff;
      border-right: 2px solid red;
  }

  .timeline-wrapper {
    /* margin: 20px auto; */
  }

  .timeline-area {
    width: calc(100% - 180px);
    height: 35px;
    background-color: #e0e0e0;
    position: relative;
    display: flex;
    cursor: pointer;
  }

  .timeline-segment-custom {
    position: absolute;
    height: 100%;
    width: 2px;
    background-color: #ff5722;
  }

  .time-display {
    margin-top: 10px;
    font-size: 18px;
    text-align: center;
    font-family: Arial, sans-serif;
  }

  .times-area{
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .times-div{
    height: 35px;
    display: flex;
    width: 90px;
    align-items: center;
    /* background-color: #007bff; */
    background-color: #2b2a3f;
    color: #fff;
    font-weight: bold;
    justify-content: center;
  }

  .style-icon-time{
    display: flex;
    width: fit-content;
  }

  .border-bottom-left-radius{
    border-bottom-left-radius: 8px;
  }

  .border-bottom-right-radius{
    border-bottom-right-radius: 8px;
  }
  
  .current-time-indicator {
  position: absolute;
  top: 0;
  height: 100%;
  width: 3px;
  background-color: rgba(255, 0, 0, 0.5); /* Vermelho sutil */
  transition: left 1s linear;
}

.elapsed-time-bar {
  position: absolute;
  height: 100%;
  background-color: rgba(0, 123, 255, 0.6); /* Azul translúcido */
  transition: width 1s linear;
}

.style-time-span{
  position: absolute;
  width: max-content;
  top: -30px;
  left: -20px;
  background-color: #007bff;
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  z-index: 9999;
}

.video-js{
  height: 60vh !important;
}

.area-loading-recording-modal{
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 99999;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.7);
}

.title-loading-recording-modal{
  color: #fff;
  font-weight: bold;
  font-size: 25pt;
}

.area-message-recording-modal{
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 99999;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.7);
}

.title-message-recording-modal{
  color: #fff;
  font-weight: bold;
  font-size: 20pt;
}

.area-message-camera-stream{
  height: 500px;
  background-color: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 20px;
}

.title-message-camera-stream{
  font-size: 18px;
  font-weight: 700;
}

.subtitle-message-camera-stream{
  color: #c7c7c7;
  font-size: 14px;
  margin-top: 6px;
}

.modal-dialog {
    --bs-modal-width: 90% !important;
}

.input-date-range{
  width: 300px !important;
}

.download-selector {
  display: flex;
  justify-content: center;
  padding: 12px 16px 0;
  background: #fff;
}

.download-selector-toggle { display: inline-flex; width: auto; align-items: center; justify-content: center; padding-right: 22px; padding-left: 22px; }
.download-selector-panel { width: 100%; padding: 16px; border: 1px solid #dedffb; border-radius: 10px; background: #f8f8ff; }
.download-selector-heading, .download-actions, .download-duration { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.download-selector-heading small { display: block; margin-top: 3px; color: #77778d; }
.download-datetime-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; margin-top: 14px; }
.download-datetime-grid label span { display: block; margin-bottom: 5px; font-size: 12px; font-weight: 600; }
.download-duration { margin-top: 12px; padding: 10px 12px; border-radius: 7px; color: #34355c; background: #eeeeff; }
.download-duration.invalid { color: #b42318; background: #fff0ed; }
.download-error { margin: 10px 0 0; color: #b42318; font-size: 13px; }
.download-processing-notice { display: flex; width: 100%; align-items: center; gap: 12px; padding: 14px 16px; border: 1px solid #a9e4c4; border-radius: 10px; color: #176b45; background: #ecfbf3; }
.download-processing-notice > i { flex: 0 0 auto; font-size: 28px; }
.download-processing-notice div { display: flex; flex-direction: column; gap: 2px; }
.download-processing-notice span { font-size: 13px; }
.download-processing-notice a { color: #3156c8; font-weight: 700; }
.download-confirmation { display: flex; flex-direction: column; gap: 4px; margin-top: 12px; padding: 12px; border-left: 3px solid #5d5fef; background: #fff; }
.download-actions { justify-content: flex-end; margin-top: 14px; }
:global(.dark) .download-selector { background: #2b2a3f; }
:global(.dark) .download-selector-panel { border-color: #4a4963; background: #343348; color: #fff; }
:global(.dark) .download-duration { color: #fff; background: #41415c; }
:global(.dark) .download-confirmation { background: #2b2a3f; }
:global(.dark) .download-processing-notice { border-color: #397a5a; color: #b9f2d0; background: #244535; }

@media screen and (max-width: 767px) {
    /* .modal-dialog {
        --bs-modal-width: 80% !important;
    } */
    .custom-device-style {
      width: 100% !important;
      max-width: 100% !important;
      margin: unset !important;
      height: 100% !important;
      overflow: hidden;
    }

    .modal-body{
      padding: unset !important;
    }

    .recording-modal-body {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      width: 100%;
      max-width: 100%;
      min-height: 0;
      overflow-y: auto;
      overflow-x: hidden;
      overscroll-behavior: contain;
      background-color: #f7f8fc;
    }

    .modal-header {
      height: auto !important;
      min-height: 56px;
      align-items: center !important;
      padding: 12px 16px;
    }

    .modal-title {
      padding-right: 12px;
      font-size: 18px !important;
      line-height: 1.3;
      overflow-wrap: anywhere;
    }

    .recording-address {
      flex: 0 0 auto;
      margin: 0;
      padding: 10px 12px;
      border-bottom: 1px solid #e8e8f2;
      background-color: #fff;
      font-size: 13px;
      line-height: 1.4;
      overflow-wrap: anywhere;
    }

    .recording-address strong {
      font-size: 13px !important;
    }

    .recording-content {
      display: flex;
      flex: 1 1 auto;
      width: 100%;
      max-width: 100%;
      min-height: 0;
      margin-top: 0 !important;
      overflow: hidden;
    }

    .recording-content-inner {
      display: flex;
      flex-direction: column;
      width: 100% !important;
      max-width: 100%;
      min-width: 0;
      min-height: 100%;
    }

    .recording-content-inner :deep(.video-player-wrapper),
    .recording-content-inner :deep(.timeline-component) {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      overflow: hidden;
    }

    .timeline-wrapper {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      margin-top: auto;
      padding: 12px 8px max(12px, env(safe-area-inset-bottom));
      border-top: 1px solid #e1e3ec;
      background-color: #fff;
      box-shadow: 0 -6px 18px rgba(43, 42, 63, 0.06);
    }

    .recording-timeline-hint {
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      justify-content: center;
      gap: 8px;
      min-height: 0;
      padding: 16px 24px;
      color: #77778d;
      font-size: 12px;
      line-height: 1.4;
      text-align: center;
    }

    .recording-timeline-hint i {
      flex: 0 0 auto;
      font-size: 18px;
    }

    .recording-controls {
      gap: 8px;
      width: 100%;
      max-width: 100%;
      min-width: 0;
      margin: 0;
    }

    .recording-search-row,
    .recording-live-row {
      width: 100%;
      margin: 0;
      padding: 0 !important;
    }

    .recording-search-row {
      display: flex;
      flex-wrap: nowrap;
      gap: 8px;
    }

    .recording-search-row .input-date-range {
      flex: 1 1 auto;
      width: auto !important;
      min-width: 0;
      height: 44px;
      margin-bottom: 0 !important;
    }

    .recording-search-row #buttonSearchRecordingsApi {
      flex: 0 0 104px;
      width: 104px;
      height: 44px;
      margin: 0 !important;
      border-radius: 7px;
    }

    .recording-live-row .live-button {
      width: 100%;
      height: 44px;
      border-radius: 7px;
    }

    .modal-content {
      height: 100vh !important;
      height: 100dvh !important;
      max-width: 100vw;
      max-height: 100dvh;
      position: fixed;
      inset: 0;
      overflow: hidden;
    }

    .input-date-range {
      width: 100% !important;
    }

    .download-selector { padding: 10px 10px 0; }
    .download-selector-toggle { width: 100%; }
    .download-selector-panel { padding: 12px; }
    .download-datetime-grid { grid-template-columns: 1fr; }

    .area-message-camera-stream{
      height: 280px !important;
    }
}

@media screen and (max-width: 420px) {
    .recording-search-row {
      flex-wrap: wrap;
    }

    .recording-search-row .input-date-range,
    .recording-search-row #buttonSearchRecordingsApi {
      flex: 1 1 100%;
      width: 100% !important;
      max-width: 100%;
    }
}

</style>
